import React, { useEffect, useState } from "react";
import ContainerInputFilter from "./ContainerInputFilter";
import NMultiRangeSlider from "components/NMultiRangeSlider";
import { VERSIONS_FILTERS_DESIGN } from "utils/constants";
import { replaceChars, capitalizeWord } from "utils";

const NMultiRangeSliderFilter = ({
  dataset,
  initialValue,
  onChange,
  isDisabled = false,
  versionInput,
}) => {
  const [min, setMin] = useState(
    initialValue?.split("<>")[0] ?? dataset?.values[0]
  );
  const [max, setMax] = useState(
    initialValue?.split("<>")[1] ?? dataset?.values[1]
  );
  const onChangeRange = (min, max) => {
    const filter_field = dataset["filter_field"];
    onChange(filter_field, min + "<>" + max, dataset);
  };

  useEffect(() => {
    setMin(initialValue?.split("<>")[0] ?? dataset?.values[0]);
    setMax(initialValue?.split("<>")[1] ?? dataset?.values[1]);
  }, [initialValue, dataset]);

  return (
    <ContainerInputFilter
      label={capitalizeWord(replaceChars(dataset?.label, "_", " "))}
      versionInput={VERSIONS_FILTERS_DESIGN.v2}
    >
      <div
        style={{
          padding: "27px 10px",
          borderRadius: "0.25rem",
          border: "1px solid",
          borderColor: "#CDD4DE",
        }}
      >
        <NMultiRangeSlider
          min={dataset?.values[0]}
          max={dataset?.values[1]}
          initialMin={initialValue?.split("<>")[0] ?? dataset?.values[0]}
          initialMax={initialValue?.split("<>")[1] ?? dataset?.values[1]}
          onChange={({ min, max }) => {
            setMin(min);
            setMax(max);
            onChangeRange(min, max);
          }}
        />
        <div style={{ marginTop: "15px", fontSize: "11px" }}>
          Entre{" "}
          <span style={{ color: "var(--secondary-color)" }}>
            {min} - {max}
          </span>{" "}
          de {replaceChars(dataset?.label, "_", " ")}
        </div>
      </div>
    </ContainerInputFilter>
  );
};
export default NMultiRangeSliderFilter;
